import clsx from 'clsx';
import React from 'react';
import PoolGuyLogo from './PoolGuyLogo';

interface AuthLayoutProps {
  children?: React.ReactNode;
  title?: string;
  subtitle?: React.ReactNode;
  loading?: boolean;
  loadingText?: string;
  stepper?: React.ReactNode; // Optional stepper component
  multiColumn?: boolean;
  headerLeft?: React.ReactNode;
}

const cardSpacing = 'px-6 md:px-10 py-10 gap-6 md:gap-8';

const AuthLayout = ({
  children,
  title,
  subtitle,
  loading = false,
  loadingText = 'Loading...',
  stepper,
  multiColumn = false,
  headerLeft,
}: AuthLayoutProps) => {
  return (
    <div className="min-h-screen w-full bg-primary flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center p-6">
        {/* Logo Header */}
        <div className="text-center mb-16 mt-8">
          <div className="flex justify-center mb-4">
            <PoolGuyLogo color="white" />
          </div>
        </div>

        {/* Optional stepper */}
        {stepper && <div className="mb-4">{stepper}</div>}

        {/* Centered Card */}
        <div
          className={clsx(
            'bg-white rounded-3xl w-full mx-auto flex flex-col',
            cardSpacing,
            multiColumn ? 'max-w-4xl' : 'max-w-lg'
          )}
        >
          {/* Title Section */}
          {(title || subtitle || headerLeft) && (
            <div className="relative flex flex-col gap-4 items-center text-center">
              {headerLeft && (
                <div className="self-start md:absolute md:left-0 md:top-0">
                  {headerLeft}
                </div>
              )}
              {title && (
                <h1
                  className={clsx(
                    'text-4xl font-bold text-dark tracking-[0.03em]',
                    headerLeft && 'md:px-24'
                  )}
                >
                  {title}
                </h1>
              )}
              {subtitle && typeof subtitle === 'string' ? (
                <h3 className="text-base font-normal text-dark">{subtitle}</h3>
              ) : (
                subtitle
              )}
            </div>
          )}

          {/* Loading State */}
          {loading ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent mx-auto mb-4"></div>
              <p className="text-medium">{loadingText}</p>
            </div>
          ) : (
            /* Content */
            children
          )}
        </div>
      </div>

      {/* Copyright Footer - Fixed at bottom */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 p-4">
        <p className="text-cloud text-center md:text-left">
          © {new Date().getFullYear()} Pool Guy Technologies Limited. All
          rights reserved.
        </p>
        <div className="flex items-center justify-center gap-8">
          <a
            href="https://getpoolguy.com/terms"
            className="text-white font-semibold"
          >
            Terms of Service
          </a>
          <a
            href="https://getpoolguy.com/privacy"
            className="text-white font-semibold"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
